import { FadeUp, Stagger, StaggerItem } from "@/components/motion/Reveal";
import { ArrowUpRight } from "lucide-react";
import { BRIDAL_STEPS, IMAGES } from "@/data/site";
import { openWhatsApp } from "@/lib/wa";

export default function BridalJourney() {
  return (
    <section
      id="gelin-turban"
      className="relative bg-beige/50 py-20 sm:py-28 overflow-hidden"
      data-testid="bridal-section"
    >
      {/* slow editorial marquee background */}
      <div className="pointer-events-none select-none absolute top-6 left-0 right-0 overflow-hidden opacity-[0.06]" aria-hidden="true">
        <div className="marquee-track">
          <span className="font-serif italic text-[9rem] leading-none whitespace-nowrap pr-16 text-espresso">
            Gelin • Nişan • Türban Tasarım • Özel Gün •
          </span>
          <span className="font-serif italic text-[9rem] leading-none whitespace-nowrap pr-16 text-espresso">
            Gelin • Nişan • Türban Tasarım • Özel Gün •
          </span>
        </div>
      </div>

      <div className="relative z-10 mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* image */}
          <FadeUp className="order-1">
            <div className="img-zoom relative rounded-t-[140px] rounded-b-3xl overflow-hidden aspect-[4/5] max-h-[70vh]">
              <img
                src={IMAGES.bridal2}
                alt="Gelin ve türban tasarımı hazırlığı"
                loading="lazy"
                className="h-full w-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-espresso/20 to-transparent" />
            </div>
          </FadeUp>

          {/* content */}
          <div className="order-2">
            <FadeUp>
              <p className="eyebrow text-gold mb-4">Gelin & Türban Tasarım</p>
            </FadeUp>
            <FadeUp delay={0.05}>
              <h2 className="font-serif text-espresso text-4xl sm:text-5xl lg:text-[3.4rem] leading-[1.03] mb-6">
                En özel gününüz, <span className="italic">size özel</span> tasarlansın.
              </h2>
            </FadeUp>
            <FadeUp delay={0.1}>
              <p className="text-espresso/70 leading-relaxed max-w-lg mb-10">
                Saç, makyaj ve türban tasarımını yüz hatlarınız, stiliniz ve özel gün
                konseptinizle uyumlu biçimde planlıyoruz.
              </p>
            </FadeUp>

            <Stagger className="grid sm:grid-cols-2 gap-x-8 gap-y-7 mb-10">
              {BRIDAL_STEPS.map((s) => (
                <StaggerItem key={s.no}>
                  <div className="flex gap-4">
                    <span className="font-serif text-4xl text-gold leading-none">{s.no}</span>
                    <div>
                      <h3 className="font-serif text-2xl text-espresso mb-1">{s.title}</h3>
                      <p className="text-sm text-espresso/65 leading-relaxed">{s.text}</p>
                    </div>
                  </div>
                </StaggerItem>
              ))}
            </Stagger>

            <FadeUp delay={0.1}>
              <button
                onClick={() =>
                  openWhatsApp(
                    "Merhaba, gelin / nişan / özel gün hazırlığı için görüşme planlamak istiyorum."
                  )
                }
                data-testid="bridal-cta"
                className="group inline-flex items-center gap-2 rounded-full bg-espresso px-8 py-4 text-ivory text-sm font-medium transition-transform duration-300 hover:scale-[1.03] active:scale-95"
              >
                Özel Gün Görüşmesi Planla
                <ArrowUpRight size={18} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </button>
            </FadeUp>
          </div>
        </div>
      </div>
    </section>
  );
}
